import { FormDatePicker, FormInput, FormSelect } from "@/components";
import useFilter from "./useFilter";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui";
import { NAME, STATUS, START_DATE, END_DATE } from "../consts";
import { X } from "lucide-react";
import { FC } from "react";
import { FilterProps } from "./types";

const Filter: FC<FilterProps> = ({ onCancel, filterData, setFilterData }) => {
  const { form, onSubmit, requiredFields, isMobile, onClear } = useFilter({
    filterData,
    setFilterData,
    onCancel,
  });
  const { errors } = form.formState;
  
  const statusoptions = [
  { label: "Active", value: "true" },
  { label: "Inactive", value: "false" },
];


  return (
    <Drawer open={true} direction={isMobile ? "bottom" : "right"}>
      <DrawerContent className="px-6">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">Filter</DrawerTitle>
            <X
              onClick={onCancel}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>

        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="relative">
            <div className="bg-white rounded-lg py-[25px] max-h-[70vh] lg:max-h-[95vh] overflow-y-auto pb-[130px] px-1">
              <div className="grid grid-cols-1 gap-[25px]">
                <FormInput
                  name={NAME}
                  control={form.control}
                  label="Region Name"
                  placeholder="Please enter"
                  error={errors[NAME]?.message}
                  isRequired={requiredFields.includes(NAME)}
                />
                <FormSelect
                    name={STATUS}
                    control={form.control}
                    label="Status"
                    placeholder="Select status"
                    options={statusoptions}
                    error={errors[STATUS]?.message}
                    isRequired={requiredFields.includes(STATUS)}
                  />
                <FormDatePicker
                  name={START_DATE}
                  control={form.control}
                  label="Start Date"
                  placeholder="Please enter"
                  error={errors[START_DATE]?.message}
                  isRequired={requiredFields.includes(START_DATE)}
                />
                <FormDatePicker
                  name={END_DATE}
                  control={form.control}
                  label="End Date"
                  placeholder="Please enter"
                  error={errors[END_DATE]?.message}
                  isRequired={requiredFields.includes(END_DATE)}
                />
              </div>
            </div>
            <div className="flex flex-col gap-3 absolute bottom-3 w-full bg-white pb-[25px] z-[3]">
              <div className="flex justify-end">
                <Button
                  variant="ghost"
                  type="button"
                  className="text-red-600"
                  onClick={onClear}
                >
                  Clear All
                </Button>
              </div>
              <Button type="submit">Apply Filter</Button>
            </div>
          </form>
        </FormProvider>
      </DrawerContent>
    </Drawer>
  );
};

export default Filter;
